import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { layout, zLayers } from '../../styles/theme';

/**
 * 家长端底部标签栏（Bottom Tab Bar）。
 * 仅在「手机 + 当前角色为家长」时由 PortalLayout 挂载（是否渲染由 PortalLayout 决定，
 * 本组件只负责展示与高亮）。给网站最直接的「App 感」：单手拇指可达的固定底部导航。
 */

const Bar = styled.nav`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${zLayers.bottomNav};
  display: flex;
  background: #ffffff;
  border-top: 1px solid #eee;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.06);
  /* iOS 底部安全区（Home 指示条） */
  padding-bottom: env(safe-area-inset-bottom, 0px);
`;

const Tab = styled(Link)`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  /* 触摸目标足够高 */
  min-height: ${layout.bottomNavHeight}px;
  padding: 6px 4px;
  text-decoration: none;
  color: ${props => (props.$active ? '#F1AF59' : '#6b7280')};
  font-size: 11px;
  font-weight: ${props => (props.$active ? 600 : 500)};
  -webkit-tap-highlight-color: transparent;

  svg {
    width: 24px;
    height: 24px;
  }

  span {
    line-height: 1;
  }
`;

const TABS = [
  {
    path: '/portal',
    label: 'Home',
    icon: (
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10" />
      </svg>
    ),
  },
  {
    path: '/portal/my-children-classes',
    label: 'Classes',
    icon: (
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
      </svg>
    ),
  },
  {
    path: '/portal/notifications',
    label: 'Notifications',
    icon: (
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
    ),
  },
  {
    path: '/portal/parent-profile',
    label: 'Profile',
    icon: (
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
  },
];

const BottomTabBar = () => {
  const location = useLocation();

  const isActive = (path) =>
    path === '/portal'
      ? location.pathname === '/portal'
      : location.pathname.startsWith(path);

  return (
    <Bar>
      {TABS.map((tab) => (
        <Tab key={tab.path} to={tab.path} $active={isActive(tab.path)}>
          {tab.icon}
          <span>{tab.label}</span>
        </Tab>
      ))}
    </Bar>
  );
};

export default BottomTabBar;
